export const CHAT_WIDTH = 320;
